/**
 * SEND ME MY BAG — the 50/50 test (Tracy 2026-10-10: "can we do a 50-50 split and test it?").
 *
 * The ask: "Pop your email in and I'll send your bag to you." Signing up ties this browser to the
 * person (snippets/cnc-signup-memory.liquid sets cnc_bind_email; the first-party pixel sends it), so
 * the abandoned-cart email can send them their bag about 2 hours later if they have not bought.
 *
 * Two arms, one per browser, kept for good:
 *   inline  the line under Checkout in the bag (snippets/cnc-bag-save.liquid), whenever it has items;
 *   popup   the same words as a panel INSIDE the bag, at the bag's exit moment only (Tracy 2026-10-11:
 *           "It should only pop at the point of in the slide cart. It shouldn't pop on a PDP ... almost
 *           an exit intent in a cart"). The moment: the shopper opened the bag themselves (the bag icon,
 *           not the automatic open after Add to bag, which is them carrying on shopping) and then goes
 *           to close it without checking out (X, the dim overlay, Escape), or on a computer the mouse
 *           leaves the window while the bag is open. That close is held once; the panel sits above
 *           the Checkout block, which stays visible and tappable, and the panel's X or the bag's X
 *           again closes the bag as normal. At most once a browser session, not again for 5 days
 *           after its X, and never anywhere but the open bag.
 * Only for people we do not know yet: not after any site sign-up, not for visitors from our emails,
 * not for logged-in customers.
 *
 * Measurement, no schema change (same pattern as the pop-up test in cnc-popup.js):
 *   exposure  email_signup_popup_event 'shown', trigger 'bagsave_ab_assign_<arm>' at assignment and
 *             'bagsave_<arm>_seen' the first time per browser the arm is actually on screen;
 *   sign-ups  'subscribed' with trigger 'bagsave_<arm>' (source 'bag_save' in the consent ledger);
 *   orders    hidden cart attributes _cnc_bagsave_ab + _cnc_popup_id, which land on the order.
 * Our own browsers (window.CNC_INTERNAL) never join an arm. QA: ?cncbag=inline or ?cncbag=popup shows
 * that arm regardless of this browser's state; nothing is logged and the cart is not tagged.
 * To end the test, set AB_FORCE to the winning arm.
 */
(function () {
  'use strict';
  if (window.__cncBagSave) return;
  window.__cncBagSave = true;

  var ENDPOINT = 'https://dkzndqkjjzhmmcebqoib.supabase.co/functions/v1/email-signup';
  var AB_KEY = 'cnc_bagsave_ab_v1';
  var DONE_KEY = 'cnc_bagsave_done_v1';
  var DISMISS_KEY = 'cnc_bagsave_dismissed_at_v1';
  var SEEN_KEY = 'cnc_bagsave_seen_v1';
  var CART_KEY = 'cnc_bagsave_ab_cart_v1';
  var SHEET_SESSION_KEY = 'cnc_bagsave_sheet_shown_v1';
  var ID_KEY = 'cnc_popup_id_v1';   /* the pop-up test's browser id, so both tests join on one id */
  var DISMISS_DAYS = 5;
  var AB_FORCE = null;
  var LINE = "Pop your email in and I'll send your bag to you.";

  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); return localStorage.getItem(k) === v; } catch (e) { return false; } }
  function ssGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }

  var qa = (location.href.match(/[?&#]cncbag=(inline|popup)\b/i) || [])[1];
  qa = qa ? qa.toLowerCase() : null;
  var internal = function () { return !!window.CNC_INTERNAL; };
  var counted = function () { return !qa && !internal(); };

  function popupId() {
    var v = lsGet(ID_KEY);
    if (!v) { v = 'p_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6); if (!lsSet(ID_KEY, v)) return null; }
    return v;
  }
  function country() {
    var p = document.querySelector('[data-cnc-popup]');
    return ((p && p.getAttribute('data-country')) || (window.Shopify && window.Shopify.country) || 'US').toUpperCase();
  }

  /* Someone we can already reach: any site sign-up in this browser, a visit from one of our emails,
     a logged-in customer. They never see the ask and never join an arm. */
  function known() {
    if (lsGet(DONE_KEY) === '1' || lsGet('cnc_popup_submitted_v1') === '1' || lsGet('cnc_from_email') === '1' || lsGet('cnc_bind_email')) return true;
    if (/[?&](utm_medium=email|_kx=)/i.test(location.search)) return true;
    var p = document.querySelector('[data-cnc-popup]');
    if (p && p.getAttribute('data-subscribed') === '1') return true;
    try { if (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.page && ShopifyAnalytics.meta.page.customerId) return true; } catch (e) {}
    return false;
  }

  function log(event, trigger) {
    if (!counted()) return;
    try {
      fetch(ENDPOINT, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true,
        body: JSON.stringify({ event: event, popup_id: popupId(), trigger: trigger, country: country() })
      }).catch(function () {});
    } catch (e) { /* never break the storefront */ }
  }

  /* The arm, assigned the first time this browser opens a bag with items while we do not know them. */
  function arm(assign) {
    if (qa) return qa;
    if (AB_FORCE) return AB_FORCE;
    var a = lsGet(AB_KEY);
    if (a === 'inline' || a === 'popup') return a;
    if (!assign || internal()) return null;
    a = Math.random() < 0.5 ? 'inline' : 'popup';
    if (!lsSet(AB_KEY, a)) return null;   /* no storage (private mode): no arm, nothing shown, not counted */
    log('shown', 'bagsave_ab_assign_' + a);
    return a;
  }

  function tagCart(a) {
    if (!counted() || ssGet(CART_KEY) === a) return;
    try {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { _cnc_bagsave_ab: a, _cnc_popup_id: popupId() } })
      }).then(function (r) { if (r.ok) ssSet(CART_KEY, a); }).catch(function () {});
    } catch (e) { /* never break the storefront */ }
  }

  function seen(a) {
    if (lsGet(SEEN_KEY) === a) return;
    if (counted()) lsSet(SEEN_KEY, a);
    log('shown', 'bagsave_' + a + '_seen');
  }

  function bagHasItems() {
    var b = document.querySelector('.quick-cart [data-checkout-btn]');
    return !!b && parseInt(b.getAttribute('data-checkout-total') || '0', 10) > 0;
  }
  function bagOpen() { return document.body.classList.contains('quick-cart-open'); }
  function dismissedRecently() {
    var d = parseInt(lsGet(DISMISS_KEY) || '0', 10);
    return !!d && (Date.now() - d) < DISMISS_DAYS * 86400000;
  }
  function eligible() { return !!qa || !known(); }

  /* The email box in the bag sits inside the cart's own form; it belongs to this one instead, so Enter
     in it sends the email and never submits the cart. */
  var ownerForm = document.createElement('form');
  ownerForm.id = 'cnc-bagsave-form';
  ownerForm.noValidate = true;
  ownerForm.hidden = true;
  document.body.appendChild(ownerForm);

  /* The popup arm's panel lives INSIDE the open bag: fixed over the bottom of the item list, its
     lower edge on the top of the Checkout block, so Checkout stays visible and tappable. It only ever
     exists while the bag is open, so it can never sit over a product page. */
  var sheet = null, holding = false, letClose = false;
  function buildSheet() {
    if (sheet) return sheet;
    sheet = document.createElement('div');
    sheet.className = 'cnc-bagsave-sheet';
    sheet.hidden = true;
    sheet.setAttribute('data-cnc-bagsave-sheet', '');
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-label', 'Send me my bag');
    sheet.innerHTML =
      '<button type="button" class="cnc-bagsave-sheet__close" aria-label="Close" data-cnc-bagsave-close>&times;</button>' +
      '<p class="cnc-bagsave-sheet__heading">Your bag, in your inbox</p>' +
      '<form class="cnc-bagsave" novalidate data-cnc-bagsave-sheetform>' +
        '<p class="cnc-bagsave__line" data-cnc-bagsave-line></p>' +
        '<div class="cnc-bagsave__row" data-cnc-bagsave-row>' +
          '<input type="email" class="cnc-bagsave__input" placeholder="Your email" autocomplete="email" aria-label="Your email" data-cnc-bagsave-input>' +
          '<button type="submit" class="cnc-bagsave__btn" data-cnc-bagsave-btn>SEND ME MY BAG</button>' +
        '</div>' +
        '<p class="cnc-bagsave__fine" data-cnc-bagsave-fine>You\'ll get our emails too. Unsubscribe any time.</p>' +
        '<p class="cnc-bagsave__msg" data-cnc-bagsave-msg role="status" hidden></p>' +
      '</form>';
    sheet.querySelector('[data-cnc-bagsave-line]').textContent = LINE;
    document.body.appendChild(sheet);
    /* Its X means what the shopper was doing when it appeared: closing the bag. */
    sheet.querySelector('[data-cnc-bagsave-close]').addEventListener('click', function () { closeSheet(true); closeBag(); });
    var f = sheet.querySelector('[data-cnc-bagsave-sheetform]');
    f.addEventListener('submit', function (e) { e.preventDefault(); send(f, 'popup'); });
    window.addEventListener('resize', placeSheet, { passive: true });
    return sheet;
  }
  function placeSheet() {
    if (!sheet || sheet.hidden) return;
    var box = document.querySelector('.quick-cart__container');
    var foot = document.querySelector('.quick-cart__footer');
    var r = box && box.getBoundingClientRect(), f = foot && foot.getBoundingClientRect();
    if (!r || !f || !r.width) return;
    sheet.style.left = Math.round(r.left) + 'px';
    sheet.style.width = Math.round(r.width) + 'px';
    sheet.style.bottom = Math.round(window.innerHeight - f.top) + 'px';
  }
  function openSheet() {
    buildSheet();
    sheet.hidden = false;
    holding = true;
    placeSheet();
    ssSet(SHEET_SESSION_KEY, '1');
    seen('popup');
  }
  function closeSheet(byShopper) {
    if (!sheet || sheet.hidden) return;
    sheet.hidden = true;
    holding = false;
    if (byShopper && lsGet(DONE_KEY) !== '1') lsSet(DISMISS_KEY, String(Date.now()));
  }
  function closeBag() {
    var c = document.querySelector('.quick-cart [data-modal-close], .quick-cart__close-icon');
    if (!c) return;
    letClose = true;
    try { c.click(); } finally { letClose = false; }
  }

  function send(scope, a) {
    var input = scope.querySelector('[data-cnc-bagsave-input]');
    var btn = scope.querySelector('[data-cnc-bagsave-btn]');
    var msg = scope.querySelector('[data-cnc-bagsave-msg]');
    var email = ((input && input.value) || '').trim();
    function say(t) { if (msg) { msg.textContent = t; msg.hidden = false; } }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { say('Please enter a valid email.'); return; }
    if (btn) btn.disabled = true;
    fetch(ENDPOINT, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: email, country: country(), source: 'bag_save', trigger: 'bagsave_' + a, popup_id: popupId(),
        form_url: location.href, consent_text: 'Subscribed to Caffeine & Curses emails via the bag ("Send me my bag")'
      })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (d) {
        if (r.ok && d && d.subscribed) {
          lsSet(DONE_KEY, '1');
          lsSet('cnc_popup_submitted_v1', '1');   /* the sign-up pop-up stops asking too */
          lsSet('cnc_bind_email', email);         /* ties this browser to them (pixel sends it once) */
          ['[data-cnc-bagsave-row]', '[data-cnc-bagsave-fine]', '[data-cnc-bagsave-line]'].forEach(function (s) {
            var el = scope.querySelector(s); if (el) el.hidden = true;
          });
          say("Done! I'll send your bag to " + email + '.');
          if (a === 'popup') setTimeout(function () { closeSheet(false); }, 2600);   /* they stay in their bag */
        } else {
          say("Couldn't do that just now. Try again in a moment.");
        }
      });
    }).catch(function () {
      say("Couldn't do that just now. Try again in a moment.");
    }).then(function () { if (btn) btn.disabled = false; });
  }

  ownerForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var block = document.querySelector('.quick-cart [data-cnc-bagsave]');
    if (block) send(block, 'inline');
  });

  /* The bag re-renders its whole section on every change, so the inline block is re-applied each time. */
  function applyInline() {
    placeSheet();   /* the bag redrew (a quantity changed): keep the panel resting on Checkout */
    var block = document.querySelector('.quick-cart [data-cnc-bagsave]');
    if (!block || !bagHasItems() || !eligible()) { if (block) block.hidden = true; return; }
    var a = arm(bagOpen());
    if (!a) { block.hidden = true; return; }
    if (bagOpen()) tagCart(a);
    if (a !== 'inline') { block.hidden = true; return; }
    if (lsGet(DONE_KEY) === '1' && !qa) { block.hidden = true; return; }
    block.hidden = false;
    if (bagOpen()) seen('inline');
  }

  /* Who opened the bag. A tap on the bag icon is the shopper coming to look at their bag; the bag
     opening by itself after Add to bag is them carrying on shopping, and closing it then is not an exit. */
  var iconTapAt = 0, openedByShopper = false, wasOpen = false;
  window.addEventListener('click', function (e) {
    if (!e.target.closest('.quick-cart') && e.target.closest('a[href$="/cart"], .header__icon--cart, [data-quick-cart-trigger]')) iconTapAt = Date.now();
  }, true);
  function trackOpen() {
    var o = bagOpen();
    if (o && !wasOpen) openedByShopper = (Date.now() - iconTapAt) < 2000;
    if (!o && wasOpen) { openedByShopper = false; closeSheet(false); }
    wasOpen = o;
  }

  /* The popup arm's moment, and the only place it can appear: the open bag, which the shopper opened
     themselves, about to be closed (or, on a computer, the mouse leaving the window) without checkout. */
  function exitMoment() {
    if (!bagOpen() || !openedByShopper || holding) return false;
    if (!bagHasItems() || !eligible() || arm(false) !== 'popup') return false;
    if (!qa && (lsGet(DONE_KEY) === '1' || dismissedRecently() || ssGet(SHEET_SESSION_KEY) === '1')) return false;
    var main = document.querySelector('[data-cnc-popup]');
    if (main && !main.hidden) return false;   /* never on top of the sign-up pop-up */
    openSheet();
    return true;
  }
  function onCloseAttempt(e) {
    if (letClose || !bagOpen()) return;
    if (holding) { closeSheet(true); return; }   /* second go: the bag closes as normal */
    if (exitMoment()) { e.preventDefault(); e.stopImmediatePropagation(); }
  }
  window.addEventListener('click', function (e) {
    if (e.target.closest('.quick-cart__close-icon, .quick-cart [data-modal-close], .quick-cart__overlay')) onCloseAttempt(e);
  }, true);
  window.addEventListener('keydown', function (e) { if (e.key === 'Escape') onCloseAttempt(e); }, true);
  if (window.matchMedia && window.matchMedia('(min-width: 990px)').matches) {
    document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0) exitMoment(); });
  }

  if (window.MutationObserver) {
    var mo = new MutationObserver(applyInline);
    var qc = document.querySelector('[data-section-type="quick-cart"]');
    if (qc) mo.observe(qc, { childList: true, subtree: true });
    new MutationObserver(function () { trackOpen(); applyInline(); }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }
  trackOpen();
  applyInline();
})();
